/**
 * 12-preset class color palette per UI mockups § "Add Class modal":
 * "Default color is auto-assigned at random from the 12-preset palette."
 *
 * Drawn from Tailwind's 500-shade family so they look good on both light
 * and dark canvases. Colors are visually distinct + don't include the
 * brand rose (which is reserved for UI chrome).
 */
export const CLASS_PALETTE = [
    '#ef4444', // red-500
    '#f97316', // orange-500
    '#eab308', // yellow-500
    '#22c55e', // green-500
    '#10b981', // emerald-500
    '#06b6d4', // cyan-500
    '#3b82f6', // blue-500
    '#6366f1', // indigo-500
    '#8b5cf6', // violet-500
    '#a855f7', // purple-500
    '#ec4899', // pink-500
    '#14b8a6', // teal-500
] as const;

/**
 * colorForClassIndex returns a consistent color for a given class_index.
 * Used as the default when a class has no explicit `color` field set.
 */
export function colorForClassIndex(idx: number): string {
    if (idx < 0) return CLASS_PALETTE[0];
    return CLASS_PALETTE[idx % CLASS_PALETTE.length];
}

/**
 * Pick the next-free color preference (least-used in this project). Used by
 * the Add Class modal as the auto-assigned default.
 */
export function nextSuggestedColor(usedColors: ReadonlyArray<string | null | undefined>): string {
    const used = new Set(usedColors.filter(Boolean) as string[]);
    for (const c of CLASS_PALETTE) {
        if (!used.has(c)) return c;
    }
    // All 12 used — fall back to a random one.
    return CLASS_PALETTE[Math.floor(Math.random() * CLASS_PALETTE.length)];
}
